import { graphql } from "react-relay";

export const ORDER_FRAGMENT = graphql`
	fragment eraseAttributionAction_OrderFragment on Order {
		id
		purchaser {
			userId
		}
	}
`;

export const ERASE_ORDER_ATTRIBUTION_MUTATION = graphql`
	mutation eraseAttributionAction_EraseOrderAttributionMutation(
		$input: EraseOrderAttributionInput!
	) {
		Admin {
			Billing {
				eraseOrderAttribution(input: $input) {
					orderId
					erasedOrderIds
				}
			}
		}
	}
`;
